export default "__VITE_ASSET__2I7slD_n__"